import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";

import FinVerification from "./pages/UIN/FinVerification.jsx";
import Dashboard from "./pages/Dashboard/Dashboard";
import Demographic from "./pages/Demographic/Demographic";
import Construction from "./pages/Construction/Construction";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { UniqueIdContext } from "./FinContext.js";
import PhoneUpdate from "./pages/PhoneUpdate/index.jsx";
import Status from "./pages/UIN/status.jsx";
import Resend from "./pages/UIN/resend.jsx";
import OTPInput from "./pages/Otp/Otp.jsx";
import CorrectDemo from "./pages/Demographic/correctDemo.jsx";
import UpdateDemo from "./pages/Demographic/updateDemo.jsx";
//import PrintableCredential from "./pages/PrintableCredential/index.jsx";


const PrivateRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

// const VerificationRoute = ({ children, isVerified }) => {
//   return isVerified ? children : <Navigate to="/" replace />;
// };



const Routings = () => {

  const isAuth = useSelector(state => state.session.isAuthenticated);
  const isVerified = useSelector(state => state.session.isVerified);
  // const { auth, otpAuth } = useContext(UniqueIdContext);
  // const isAuthenticated = auth;
  // const isAuth = otpAuth;

  return (
    <Routes>
      <Route path="/"
        element={
          <FinVerification />
          // <Dashboard />

        }
      />

      <Route path="/callback"
        element={
          <FinVerification />
          // <Dashboard />

        }
      />

      <Route
        path="/otp"
        element={
          // <PrivateRoute isAuthenticated={isVerified}>
          <OTPInput />
          // </PrivateRoute>
        }
      />
      <Route
        path="/phoneUpdate"
        element={<PhoneUpdate />}
      />
      <Route
        path="/dashboard"
        element={
          // <PrivateRoute isAuthenticated={isAuth}>
          <Dashboard />
          // </PrivateRoute>
        }
      />
      <Route
        path="/correctdemo"
        element={
          <PrivateRoute isAuthenticated={isAuth}>
            <CorrectDemo />
          </PrivateRoute>
        }
      />
      <Route
        path="/updatedemo"
        element={
          <PrivateRoute isAuthenticated={isAuth}>
            <UpdateDemo />
          </PrivateRoute>
        }
      />
      <Route
        path="/construction"
        element={
          <PrivateRoute isAuthenticated={isAuth}>
            <Construction />
          </PrivateRoute>
        }
      />
      <Route
        path="/resend"
        element={
          // <PrivateRoute isAuthenticated={isAuth}>
          <Resend />
          // </PrivateRoute>
        }
      />
      <Route
        path="/status"
        element={
          // <PrivateRoute isAuthenticated={isAuth}>
          <Status />
          // </PrivateRoute>
        }
      />
      {/* <Route
        path="/PrintableCredential"
        element={
          <PrivateRoute isAuthenticated={isAuth}>
          <PrintableCredential />
          </PrivateRoute>
        }
      /> */}
    </Routes>
  );
};

export default Routings;
